import { createActionName } from "redux/utility"

export const reducerName = "prerequisites"

export const PREREQUISITE = createActionName(reducerName, "PREREQUISITE")
export const PREREQUISITES = createActionName(reducerName, "PREREQUISITES")
